import React, { Component } from "react";
import { Select } from "antd";
import { ModalItem, SelectItem } from "../../../../Components/Items";
import axios from "axios";
import { connect } from "react-redux";
import { notification } from "antd";

const { Option } = Select;

class ModalAsignarVendedores extends Component {
  state = {
    usuarios: [],
    seleccionados: [],
    cargando: false,
    guardando: false,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      if (this.props.embudo) {
        this.cargarDatos();
      }
    }
    if (!this.props.visible && prevProps.visible) {
      this.setState({ usuarios: [], seleccionados: [] });
    }
  }

  cargarDatos = () => {
    const { empresaId, headersToken, embudo } = this.props;

    this.setState({ cargando: true });

    Promise.all([
      axios.post(
        "usuarios/selectUsuariosEmpresa",
        { empresaId },
        { headers: headersToken },
      ),
      axios.post(
        "embudos/obtenerUsuariosEmbudo",
        { embudoId: embudo._id },
        { headers: headersToken },
      ),
    ])
      .then(([resUsuarios, resAsignados]) => {
        if (Array.isArray(resUsuarios.data)) {
          this.setState({ usuarios: resUsuarios.data });
        }
        if (resAsignados.data.success === 2) {
          this.setState({
            seleccionados: resAsignados.data.usuarios.map((u) =>
              u._id.toString(),
            ),
          });
        }
      })
      .catch(() =>
        notification.error({ message: "Error al cargar los usuarios." }),
      )
      .finally(() => this.setState({ cargando: false }));
  };

  guardar = () => {
    const { headersToken, embudo, onExito } = this.props;
    const { seleccionados } = this.state;

    this.setState({ guardando: true });

    axios
      .post(
        "embudos/asignarUsuariosEmbudo",
        { embudoId: embudo._id, usuarioIds: seleccionados },
        { headers: headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          notification.success({ message: "Vendedores asignados correctamente." });
          onExito?.();
        } else {
          notification.error({ message: res.data.message || "Error al guardar." });
        }
      })
      .catch(() => notification.error({ message: "Error de red al guardar." }))
      .finally(() => this.setState({ guardando: false }));
  };

  handleCancel = () => {
    this.setState({ seleccionados: [], usuarios: [] });
    this.props.onCancel?.();
  };

  render() {
    const { visible, embudo } = this.props;
    const { usuarios, seleccionados, cargando, guardando } = this.state;

    return (
      <ModalItem
        title={`Vendedores con acceso — ${embudo?.nombreEmbudo ?? ""}`}
        visible={visible}
        onOk={this.guardar}
        onCancel={this.handleCancel}
        okText="Guardar"
        cancelText="Cancelar"
        confirmLoading={guardando}
        spinning={cargando}
        footer
        destroyOnClose
      >
        <p style={{ marginBottom: 12, color: "#555", fontSize: 13 }}>
          Selecciona los vendedores que podrán ver y trabajar en este embudo.
          Si dejas la lista vacía, <strong>todos los usuarios</strong> de la
          empresa tendrán acceso.
        </p>

        <SelectItem
          mode="multiple"
          style={{ width: "100%" }}
          placeholder="Selecciona vendedores..."
          value={seleccionados}
          onChange={(val) => this.setState({ seleccionados: val })}
          allowClear
        >
          {usuarios.map((u) => (
            <Option key={u._id} value={u._id.toString()}>
              {`${u.nombre} ${u.apellidoPaterno ?? ""}`.trim()}
            </Option>
          ))}
        </SelectItem>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalAsignarVendedores);
